export default __webpack_public_path__ + "static/media/526.fa68f6c3.png";